var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarDropdownArrow = function SvgCalendarDropdownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "calendarDropdownArrow_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#calendarDropdownArrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A8447",
    d: "m11.52 14.174-3.151-3.151a.5.5 0 0 1-.103-.146.458.458 0 0 1 .087-.492.42.42 0 0 1 .327-.135h6.639q.203 0 .327.137a.46.46 0 0 1 .124.32q0 .045-.14.316l-3.15 3.151a.638.638 0 0 1-.48.209.64.64 0 0 1-.48-.209"
  }))));
};
export default SvgCalendarDropdownArrow;